
<template>
  <div id="app" :class="{focusProject: focusedProject}">
    <transition :name="'fade'">
      <Main></Main>
    </transition>
  </div>
</template>

<script>
import Main from "./components/main/Main.vue";

export default {
  name: "App",
  components: { Main },
  data: function() {
    return {
      transitionName: null,
      focusedProject: null,
      currentRoute: window.location.pathname
    };
  },
  methods: {
    selectProject: function(project) {
      this.focusedProject = project;
    }
  }
  /*   watch: {
    $route(to, from) {
      const toDepth = to.path.split("/").length;
      const fromDepth = from.path.split("/").length;
      this.transitionName = toDepth < fromDepth ? "slide-top" : "slide-bottom";
    }
  } */
};
</script>

<style lang="scss">
@import "./App.scss";
</style>